import { GlassWater, Ticket } from "lucide-react";
import { Link } from "react-router-dom";


const positions = [
  { icon: GlassWater, title: "Barkeeper & Service", desc: "Drinks, Gastfreundschaft & Teamwork" },
  { icon: Ticket, title: "Kasse & Garderobe", desc: "Empfang, Abrechnung & Organisation" },
];

const JoinUs = () => {
  return (
    <section className="py-16 px-4 bg-secondary/30 border-t border-border/30">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center text-2xl md:text-3xl font-semibold text-primary mb-1">
          Wir suchen Dich!
        </h2>
        <p className="text-center text-foreground/60 font-[Montserrat] text-xs tracking-[0.15em] uppercase mb-8">
          Werde Teil der Luther Club Familie
        </p>

        <div className="grid md:grid-cols-[240px_1fr] gap-8 items-center">
          {/* Image */}
          <div className="rounded overflow-hidden border border-border self-stretch">
            <img
              src="/images/join-us.avif"
              alt="Luther Club Team – Wir suchen Verstärkung"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Content */}
          <div className="space-y-6">
            <p className="text-foreground/80 text-base leading-relaxed">
              Du hast Lust auf Nachtleben und bringst Motivation mit? Wir suchen
              Verstärkung für unser Team im Luther Club Kaiserslautern. Bei uns
              erwartet dich ein starkes Team, ein faires Miteinander und
              unvergessliche Nächte in einzigartiger Atmosphäre. Egal ob du bereits
              Erfahrung in der Gastronomie hast oder einfach Lust auf etwas Neues –
              bei uns bist du willkommen!
            </p>

            <div className="space-y-3">
              {positions.map((pos) => (
                <div
                  key={pos.title}
                  className="flex items-start gap-4 p-4 rounded border border-border/50 bg-card/50"
                >
                  <pos.icon className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                  <div>
                    <h3 className="font-semibold text-foreground">{pos.title}</h3>
                    <p className="text-sm text-muted-foreground">{pos.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <p className="text-foreground/60 text-sm">
              Erfahrung ist von Vorteil, aber kein Muss – Motivation und Zuverlässigkeit zählen!
            </p>

            <Link
              to="/jobs"
              className="inline-flex items-center gap-2 font-[Montserrat] text-sm tracking-[0.15em] uppercase px-7 py-3 bg-primary text-primary-foreground rounded hover:bg-primary/90 transition-colors"
            >
              Jetzt bewerben
            </Link>

          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinUs;
